import e from"../styles/theme.js";const r=e=>{if(e)return e.normalize("NFKD").toLowerCase().trim().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-")},t=r=>e.palette?.[r].main;export{t as getColors,r as stringToSlug};
//# sourceMappingURL=helpers.js.map
